var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.load)?_c('ui-loader'):_vm._e(),(_vm.result && _vm.result.data)?_c('renderer',{attrs:{"result":_vm.result && _vm.result.data}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }